export const MEDIA_PATH_SEGMENTS = {
  INCOMING: 'in-arrivo',
}

export const MEDIA_KIND = {
  CLOTH: 'Telo',
  COMPATIBLE: 'Compatibile',
  PROPRIETARY: 'Proprietaria',
}
